import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WELL_SEARCH_OPTIONS } from '../../../shared/helpers/app.constants';
import { WellSearchSettingsService } from '../../../shared/services/well-search-settings.service';
import { Subject, of } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { isEmpty } from 'lodash';

@Component({
  selector: 'app-well-search-settings',
  templateUrl: './well-search-settings.component.html',
  styleUrls: ['./well-search-settings.component.scss']
})
export class WellSearchSettingsComponent implements OnInit, OnDestroy {
  destroy$: Subject<any> = new Subject();
  curCompanyId: number;
  paramOptions: any[] = WELL_SEARCH_OPTIONS;
  selected = null;
  selectedOptions: any[] = [];

  @Input()
  set companyId(id: number) {
    if (this.curCompanyId !== id) {
      this.curCompanyId = id;
    }
  }

  constructor(
    private wellSearchSettingsService: WellSearchSettingsService,
  ) { }


  ngOnInit() {
    this.wellSearchSettingsService.getSettings()
      .pipe(switchMap(items => {
        if (isEmpty(items)) {
          return this.wellSearchSettingsService.createDefaultSettings()
            .pipe(switchMap(res => {
              return this.wellSearchSettingsService.getSettings()
            }))
        } else {
          return of(items);
        }
      }))
      .pipe(takeUntil(this.destroy$))
      .subscribe((items => {
        this.selectedOptions = items;
      }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }

  onSelectParam(eventData) {
    console.log(eventData)
  }

  onChangeParam(name, item) {
    if (item && item.id && name) {
      this.wellSearchSettingsService.updateSettings(item.id, { name: name, order: item.order })
        .pipe(switchMap(res => {
          return this.wellSearchSettingsService.getSettings();
        }))
        .pipe(tap(items => {
          this.selectedOptions = items;
        }))
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }
  }

  onAddParam(item) {
    if (item) {
      const isExisted = this.selectedOptions.find(opt => opt.name === item.name);
      if (!isExisted) {
        this.selectedOptions.push(item);
        this.selected = null;
        this.wellSearchSettingsService.createSetting({ name: item.name, order: this.selectedOptions.length })
          .pipe(switchMap(res => {
            return this.wellSearchSettingsService.getSettings();
          }))
          .pipe(tap(items => {
            this.selectedOptions = items;
          }))
          .pipe(takeUntil(this.destroy$))
          .subscribe();
      }
    }
  }

  deleteParam(e, item, index) {
    if (item && item.id) {
      this.wellSearchSettingsService.deleteSetting(item.id)
        .pipe(switchMap(res => {
          return this.wellSearchSettingsService.getSettings();
        }))
        .pipe(tap(items => {
          this.selectedOptions = items;
        }))
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }
  }

}
